module.exports = __webpack_public_path__ + "static/media/windshield-selected.938b27f0.svg";